import React from 'react';
import CodeRenderer from './CodeRenderer';
import { useSelector } from 'react-redux';
import SymbolMultipleChoice from 'pages/Chart/SymbolHandler/SymbolMultipleChoice';
import SymbolMultiDialog from 'pages/Chart/SymbolHandler/SymbolMultiDialog';



export const CodeHandler = () => {
	const active      = useSelector(state => {
			  let { toolbar, symbolOptions } = state.chart;
			  return toolbar.selectedButton === 'symbols' && symbolOptions.screenPoint !== null;
		  }),
		  tool        = useSelector(state => state.chart.toolbar.selectedTool),
		  symbolID    = useSelector(state => state.chart.symbolOptions.symbol),
		  point       = useSelector(state => state.chart.symbolOptions.screenPoint),
		  handlerConf = useSelector(state => state.chart.symbolOptions.handlerConf),
		  width       = 500;

	if(!active) {
		return null;
	}

	console.log({ handlerConf });

	if(handlerConf !== null) {
		switch(handlerConf.type) {
			case 'multiselect':
				return <SymbolMultipleChoice
					handlerConf={handlerConf}
					point={point}
					symbolID={symbolID}
				/>;
			case 'input':
				return <CodeRenderer
					codeConfig={handlerConf}
				/>;
			default:
				return null;
		}
	}


	if(tool === 'symbolMulti') {
		const styleConfig = {
			position: 'fixed',
			display: 'block',
			opacity: 1,
			zIndex: 100,
			left: (point[ 0 ] + width + 72) > window.innerWidth
				? window.innerWidth - 72 - width
				: point[ 0 ] - 200,
			top: (point[ 1 ] + 700) > window.innerHeight
				? window.innerHeight - 800
				: point[ 1 ] - 50,
		};

		return (
			<SymbolMultiDialog
				styleConfig={styleConfig}
			/>
		);
	}

};

export default CodeHandler;
